import { RepairCategory } from "types/restarter";

export const REPAIR_STATUSES = {
  FIXED: { label: "FIXED", color: "success", emoji: "😊" },
  REPAIRABLE: { label: "REPAIRABLE", color: "warning", emoji: "😐" },
  "IN PROGRESS": { label: "IN PROGRESS", color: "info", emoji: "🤔" },
  "END OF LIFE": { label: "END OF LIFE", color: "error", emoji: "🙁" },
};

export const REPAIR_CATEGORIES: RepairCategory[] = [
  {
    powered: true,
    label: "Aircon/dehumidifier",
    emoji: "💨",
    description:
      "Home/office appliance that adjusts ambient air quality. Brands examples: Dyson, Meaco.",
  },
  {
    powered: true,
    label: "Coffee maker",
    emoji: "☕️",
    description:
      "Powered filter or espresso machine, Nespresso etc. Brands examples: De'Longhi, Nespresso.",
  },
  {
    powered: true,
    label: "Decorative or safety lights",
    emoji: "💡",
    description:
      "Bike lights, night lights, torches, fairy lights etc. Brands examples: Cateye, Duracell.",
  },
  {
    powered: true,
    label: "Desktop computer",
    emoji: "🖥️",
    description:
      "Tower, mini tower, midi tower, desktop, all-in-one, unibody. Brands examples: Apple, Dell, HP.",
  },
  {
    powered: true,
    label: "Digital compact camera",
    emoji: "📷",
    description: "Smaller electronic cameras. Brands examples: Canon, Sony.",
  },
  {
    powered: true,
    label: "DSLR/video camera",
    emoji: "📹",
    description:
      "Larger electronic cameras. Brands examples: Canon, Sony, Nikon.",
  },
  {
    powered: true,
    label: "Fan",
    emoji: "🌬️",
    description: "Cooling fan, fan heater. Brands examples: Dyson, Meaco.",
  },
  {
    powered: true,
    label: 'Flat screen 15-17"',
    emoji: "📺",
    description: "Smaller TVs and monitors. Brands examples: Samsung, LG.",
  },
  {
    powered: true,
    label: 'Flat screen 19-20"',
    emoji: "📺",
    description: "TVs and monitors. Brands examples: Samsung, LG.",
  },
  {
    powered: true,
    label: 'Flat screen 22-24"',
    emoji: "📺",
    description: "TVs and monitors. Brands examples: Samsung, LG.",
  },
  {
    powered: true,
    label: 'Flat screen 26-30"',
    emoji: "📺",
    description: "TVs and monitors. Brands examples: Samsung, LG.",
  },
  {
    powered: true,
    label: 'Flat screen 32-37"',
    emoji: "📺",
    description: "Larger TVs and monitors. Brands examples: Samsung, LG.",
  },
  {
    powered: true,
    label: "Games console",
    emoji: "🎮",
    description:
      'Games boxes e.g. Playstation, XBox. Note that a small console may be classified as a "Handheld entertainment device". Brands examples: Sony, Microsoft.',
  },
  {
    powered: true,
    label: "Hair & beauty item",
    emoji: "💅",
    description:
      "Hair straighteners, hair dryers, toothbrushes, shavers etc. Brands examples: Dyson, ghd.",
  },
  {
    powered: true,
    label: "Handheld entertainment device",
    emoji: "📱",
    description:
      "iPods, Walkmans, handheld audio players, portable game consoles (e.g. Nintendo Switch, PSP). Brands examples: Apple, Sony, Nintendo.",
  },
  {
    powered: true,
    label: "Headphones",
    emoji: "🎧",
    description:
      "Earbuds, bluetooth buds, on-ear and over-ear cups and headsets. Brands examples: Apple, Sony, Bose.",
  },
  {
    powered: true,
    label: "Hi-Fi integrated",
    emoji: "📻",
    description:
      'Mini-stereos and "Boom Boxes". Brands examples: Sony, Panasonic.',
  },
  {
    powered: true,
    label: "Hi-Fi separates",
    emoji: "🎛️",
    description:
      "Any component of a stereo system. Brands examples: Denon, Marantz.",
  },
  {
    powered: true,
    label: "Iron",
    emoji: "👔",
    description:
      "Steam or non-steam clothes iron, travel iron. Brands examples: Philips, Tefal.",
  },
  {
    powered: true,
    label: "Kettle",
    emoji: "🫖",
    description:
      "Powered appliance for boiling water. Brands examples: Russell Hobbs, Breville.",
  },
  {
    powered: true,
    label: "Lamp",
    emoji: "💡",
    description:
      "Desk lamp, floor lamp, wall lamp. Brands examples: IKEA, Philips.",
  },
  {
    powered: true,
    label: "Laptop large",
    emoji: "💻",
    description:
      "Any laptop larger than 15 inch - mostly for graphics and gaming. Brands examples: Apple, Dell, HP.",
  },
  {
    powered: true,
    label: "Laptop medium",
    emoji: "💻",
    description: "Most laptops. Brands examples: Apple, Dell, HP.",
  },
  {
    powered: true,
    label: "Laptop small",
    emoji: "💻",
    description: "Netbooks or ultrabooks. Brands examples: Apple, Dell, HP.",
  },
  {
    powered: true,
    label: "Misc",
    emoji: "❓",
    description:
      "Any powered device that does not fit in another category. Brands examples: N/A.",
  },
  {
    powered: true,
    label: "Mobile",
    emoji: "📱",
    description:
      "Any hand-held smartphone or other telecommunications device. Brands examples: Apple, Samsung.",
  },
  {
    powered: true,
    label: "Musical instrument",
    emoji: "🎸",
    description:
      "Any powered instrument e.g. keyboard, guitar. Brands examples: Yamaha, Fender.",
  },
  {
    powered: true,
    label: "Paper shredder",
    emoji: "📄",
    description:
      "Home/office appliance for shredding documents. Brands examples: Fellowes, Rexel.",
  },
  {
    powered: true,
    label: "PC accessory",
    emoji: "🖱️",
    description:
      "Mice, keyboards, webcams, laptop chargers etc. Brands examples: Logitech, Microsoft.",
  },
  {
    powered: true,
    label: "Portable radio",
    emoji: "📻",
    description:
      "Transistor, digital, clock/radio devices etc. Brands examples: Roberts, Pure.",
  },
  {
    powered: true,
    label: "Power tool",
    emoji: "🛠️",
    description:
      "Powered DIY and garden tools and devices, e.g. jigsaw, leafblower. Brands examples: Bosch, DeWalt.",
  },
  {
    powered: true,
    label: "Printer/scanner",
    emoji: "🖨️",
    description:
      "Any inkjet, laserjet, scanner, copier or combination appliance. Brands examples: HP, Canon, Epson.",
  },
  {
    powered: true,
    label: "Projector",
    emoji: "📽️",
    description:
      "Slide projector, video projector, digital projector, home theatre. Brands examples: Epson, BenQ.",
  },
  {
    powered: true,
    label: "Sewing machine",
    emoji: "🧵",
    description:
      "Powered appliance for stitching fabric including overlocker. Brands examples: Singer, Brother.",
  },
  {
    powered: true,
    label: "Small kitchen item",
    emoji: "🍳",
    description:
      "Blenders, grinders, food processors, bread makers etc. Brands examples: Nutribullet, Kenwood.",
  },
  {
    powered: true,
    label: "Tablet",
    emoji: "📱",
    description:
      "Any screen over 6 inch including Kindles and satnavs. Brands examples: Apple, Samsung, Amazon.",
  },
  {
    powered: true,
    label: "Toaster",
    emoji: "🍞",
    description:
      "Kitchen appliance for browning baked goods. Brands examples: Dualit, Breville.",
  },
  {
    powered: true,
    label: "Toy",
    emoji: "🧸",
    description:
      "Any mains or battery powered toy. Brands examples: LEGO, Hasbro.",
  },
  {
    powered: true,
    label: "TV and gaming-related accessories",
    emoji: "📺",
    description:
      "Setup boxes, DVD players, game controllers etc. Brands examples: Sony, Microsoft.",
  },
  {
    powered: true,
    label: "Vacuum",
    emoji: "🧹",
    description:
      "Includes hand-held vacuums and steam mop. Brands examples: Dyson, Shark.",
  },
  {
    powered: true,
    label: "Watch/clock",
    emoji: "⌚️",
    description:
      "Any electronic time-keeping or fitness monitoring device. Brands examples: Apple, Fitbit.",
  },
  {
    powered: false,
    label: "Bicycle",
    emoji: "🚲",
    description:
      "Entire bicycle. Note that bicycle accessories may fit into another category, e.g. bike lights.",
  },
  {
    powered: false,
    label: "Clothing/textile",
    emoji: "👕",
    description: "Clothes, soft-furnishings or other fabric/textile items.",
  },
  {
    powered: false,
    label: "Furniture",
    emoji: "🛋️",
    description: "Larger household items such as chairs and tables.",
  },
  {
    powered: false,
    label: "Hand tool",
    emoji: "🔨",
    description:
      "Non-electrical tools such as saws, hammers, secateurs and spades.",
  },
  {
    powered: false,
    label: "Jewellery",
    emoji: "💍",
    description:
      "Small, personal ornaments, such as earrings, necklaces and bracelets, also spectacles.",
  },
  {
    powered: false,
    label: "Misc",
    emoji: "❓",
    description:
      "Items that do not require power and that do not fit into another category.",
  },
];
